export interface Article {
  id: string;
  title: string;
  summary: string;
  category: string;
  tags: string[];
  cover: string;
  author: string;
  publishTime: string;
  views: number;
  shares: number;
  featured: boolean;
  paragraphs: string[];
  gallery: string[];
}

export const articles: Article[] = [
  {
    id: 'n1',
    title: '现象级古装剧《长风渡月》收官，口碑逆袭登顶年度剧集榜',
    summary: '开播时被质疑节奏慢，收官却拿下年度最高评分，《长风渡月》用一场漂亮的翻身仗证明了慢热剧的耐心。',
    category: 'news',
    tags: ['剧集', '古装', '口碑'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%2C%20warm%20orange%20lantern%20glow%2C%20cinematic%20fantasy%20drama%20poster%20mood%2C%20silhouetted%20elegant%20figures%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-n1&orientation=landscape',
    author: '91吃瓜编辑部',
    publishTime: '2026-10-16T09:20:00',
    views: 42800,
    shares: 1860,
    featured: true,
    paragraphs: [
      '由新锐导演沈砚执导，林知夏、顾城南领衔主演的古装剧《长风渡月》于本周正式收官。该剧开播首周因叙事节奏偏慢引发讨论，但随着中段剧情展开，评分一路走高，收官当日拿下了年度剧集榜的最高分。',
      '剧集改编自同名小说，讲述乱世之中一位女官与一位边关将领在朝堂与沙场之间的抉择。剧组在服化道上的考据获得观众好评，尤其是长达四分钟的一镜到底攻城戏，被不少剧迷称为“国产古装近年最有诚意的场面”。',
      '业内人士分析，《长风渡月》的逆袭说明观众对“慢热”内容仍有耐心，关键在于后段能否给出足够的情感兑现。该剧的长尾播放数据仍在持续增长，多家平台已就出海发行展开接洽。',
      '导演沈砚在收官长文中致谢剧组，并透露下一部作品仍在筹备阶段，题材将转向现代都市。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20film%20set%20with%20cameras%20and%20warm%20orange%20lighting%2C%20behind%20the%20scenes%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-01&orientation=landscape',
    ],
  },
  {
    id: 'n2',
    title: '第38届金映奖提名公布：多位实力派演员首次入围',
    summary: '本届金映奖提名名单出炉，现实题材与中小成本作品表现抢眼，多位陪伴观众多年的实力派演员首次获得提名。',
    category: 'news',
    tags: ['颁奖礼', '电影', '行业'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20grand%20awards%20ceremony%20stage%2C%20golden%20trophy%20glow%2C%20warm%20orange%20spotlights%2C%20elegant%20atmosphere%2C%20cinematic%20poster%20composition%2C%20charcoal%20and%20amber%20tones%2C%20no%20text&width=800&height=500&seq=art-n2&orientation=landscape',
    author: '影展观察员',
    publishTime: '2026-10-16T08:05:00',
    views: 27600,
    shares: 940,
    featured: true,
    paragraphs: [
      '第38届金映奖昨日公布提名名单，共设二十一个奖项。本届最大看点来自现实题材的集中爆发，三部中小成本影片同时入围最佳影片，成为近五年罕见的现象。',
      '在表演类奖项中，多位长期在配角位置上打磨的演员首次获得主角提名。评委会在说明中表示，今年的评选更强调“角色完成度”而非阵容大小，希望把注意力还给作品本身。',
      '技术类奖项方面，摄影与声音设计竞争激烈，两部风格迥异的作品被认为难分伯仲。颁奖典礼将于下月中旬举行，届时将同步公布观众票选结果。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20crowded%20red%20carpet%20event%20with%20warm%20orange%20flash%20lights%2C%20glamorous%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-02&orientation=landscape',
    ],
  },
  {
    id: 'n3',
    title: '国产科幻大片《银河回响》定档春节，首支预告引爆期待',
    summary: '耗时四年制作的科幻电影《银河回响》正式定档春节，首支预告上线十小时播放量破亿，视觉奇观成为最大卖点。',
    category: 'news',
    tags: ['电影', '科幻', '定档'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20movie%20poster%20illustration%20of%20a%20giant%20planet%20above%20a%20futuristic%20city%20skyline%2C%20warm%20orange%20and%20charcoal%20palette%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=art-n3&orientation=landscape',
    author: '91吃瓜编辑部',
    publishTime: '2026-10-15T21:40:00',
    views: 51900,
    shares: 2310,
    featured: true,
    paragraphs: [
      '筹备四年、拍摄周期长达十一个月的科幻电影《银河回响》于昨晚官宣定档春节档，并放出首支预告。预告片上线十小时内播放量突破一亿，相关话题连续占据热搜前列。',
      '影片讲述一支深空勘探队在信号失联后重新建立联系的故事，导演在采访中强调，影片的核心并非特效，而是“人在巨大孤独中的相互确认”。',
      '从预告呈现的画面看，影片在空间站内部结构与行星地表景观上投入巨大，美术团队为此搭建了超过一万平方米的实景棚。制片方表示，影片将同步推出巨幕版本，观众的观影体验是这次创作的重要考量。',
      '业内预计，该片有望成为明年春节档最受关注的国产作品之一。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20movie%20ticket%20stub%20and%20popcorn%20with%20warm%20orange%20cinema%20light%2C%20cozy%20movie%20night%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-05&orientation=landscape',
    ],
  },
  {
    id: 'n4',
    title: '音乐综艺《声生不息·新声季》开播，素人选手一夜走红',
    summary: '新一季音乐综艺主打“素人舞台”，首播夜一位外卖骑手的原创歌曲打动全场，话题阅读量迅速攀升。',
    category: 'news',
    tags: ['综艺', '音乐', '素人'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20modern%20music%20competition%20stage%20with%20a%20single%20spotlight%20singer%2C%20warm%20orange%20stage%20lights%2C%20crowd%20silhouettes%2C%20cinematic%20poster%20mood%2C%20charcoal%20and%20amber%20tones%2C%20no%20text&width=800&height=500&seq=art-n4&orientation=landscape',
    author: '综艺观察',
    publishTime: '2026-10-15T19:10:00',
    views: 33200,
    shares: 1420,
    featured: false,
    paragraphs: [
      '音乐综艺《声生不息·新声季》昨晚开播，本季取消了明星竞演设定，改为面向普通人的原创音乐舞台。首播夜，一位白天送外卖、晚上写歌的选手带来原创曲目《回家的路》，唱哭了不少观众。',
      '节目制作人表示，这一季希望让“音乐回归表达本身”，因此弱化了排名与淘汰机制，把更多镜头留给创作过程。',
      '首播数据显示，节目在年轻观众中的完播率明显高于同期综艺。有评论认为，把舞台交给素人，反而让节目找回了久违的真实感。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20recording%20studio%20microphone%20with%20warm%20orange%20glow%2C%20music%20production%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-03&orientation=landscape',
    ],
  },
  {
    id: 'n5',
    title: '贺岁档前哨战打响：三部电影同日官宣定档',
    summary: '同一天内三部题材各异的影片宣布锁定贺岁档，喜剧、悬疑与现实题材正面相遇，档期竞争提前升温。',
    category: 'news',
    tags: ['电影', '档期', '市场'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20three%20cinema%20screens%20glowing%20in%20a%20dark%20theater%2C%20warm%20orange%20projection%20light%2C%20seats%20silhouettes%2C%20editorial%20magazine%20style%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-n5&orientation=landscape',
    author: '91吃瓜编辑部',
    publishTime: '2026-10-14T16:30:00',
    views: 18400,
    shares: 610,
    featured: false,
    paragraphs: [
      '贺岁档的战火提前点燃。昨日，三部影片在同一天官宣定档，分别为一部合家欢喜剧、一部犯罪悬疑片和一部现实题材作品，题材分布几乎覆盖了不同观影人群。',
      '多位院线经理表示，今年贺岁档的排片会更加分散，单片冲击高票房的空间被压缩，但整体大盘有望保持稳定。',
      '分析人士指出，同日定档更多是一种宣发策略，真正的胜负仍取决于口碑。对观众来说，选择变多，无疑是一件好事。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20television%20talk%20show%20set%20with%20warm%20orange%20accents%2C%20modern%20studio%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-04&orientation=landscape',
    ],
  },
  {
    id: 'n6',
    title: '综艺市场回暖：观察类真人秀成新宠，多平台加码布局',
    summary: '在竞演类节目进入疲态之后，观察类真人秀凭借低门槛与高话题度重新赢得市场，多家平台公布新一轮排播计划。',
    category: 'news',
    tags: ['综艺', '市场', '观察类'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20bright%20modern%20television%20studio%20set%20with%20soft%20lighting%2C%20warm%20orange%20accents%2C%20geometric%20backdrop%2C%20editorial%20magazine%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=art-n6&orientation=landscape',
    author: '综艺观察',
    publishTime: '2026-10-14T11:05:00',
    views: 14200,
    shares: 430,
    featured: false,
    paragraphs: [
      '经历了两年的调整期，综艺市场呈现回暖迹象。与以往不同的是，这一轮增长的推动力来自观察类真人秀，而非传统的竞演节目。',
      '观察类节目以真实生活场景为底本，制作成本相对可控，同时天然具备社交话题度，因而受到平台青睐。多档新节目已在筹备中，主题涵盖职场、独居与代际沟通。',
      '有制作人坦言，观众的耐心正在变短，节目必须在开头三分钟就建立情感连接。内容与真实，成为这一轮竞争的关键词。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20social%20media%20trending%20phone%20screen%20with%20warm%20orange%20notification%20glow%2C%20internet%20buzz%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-06&orientation=landscape',
    ],
  },
  {
    id: 's1',
    title: '演员林知夏官宣新剧合作，时隔三年回归古装题材',
    summary: '在《长风渡月》收官热度未散之际，林知夏宣布将主演一部新古装剧，这也是她时隔三年再次挑战古装角色。',
    category: 'star',
    tags: ['林知夏', '古装', '新剧'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20portrait%20illustration%20of%20an%20elegant%20asian%20actress%20in%20a%20flowing%20ancient%20costume%2C%20warm%20orange%20backlight%2C%20soft%20bokeh%2C%20editorial%20magazine%20cover%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-s1&orientation=landscape',
    author: '明星组',
    publishTime: '2026-10-16T10:10:00',
    views: 38600,
    shares: 2240,
    featured: true,
    paragraphs: [
      '凭借《长风渡月》再度收获高口碑的演员林知夏，昨日通过工作室宣布将主演新一部古装剧《雁书行》，该剧预计于明年初开机。',
      '这也是林知夏时隔三年再次挑战古装角色。她在采访中坦言，上一部作品让她对古装表演有了新的理解，“这一次我想演一个更有锋芒的人”。',
      '据透露，新剧将采用实景拍摄为主的方式，主创团队此前以拍摄群像戏见长。粉丝在社交平台表示期待，相关话题当晚登上热搜前列。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20crowded%20red%20carpet%20event%20with%20warm%20orange%20flash%20lights%2C%20glamorous%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-02&orientation=landscape',
    ],
  },
  {
    id: 's2',
    title: '歌手程野世界巡演官宣，五城门票开售即罄',
    summary: '程野宣布启动新一轮世界巡演，首站与加场信息同步公开，五个城市门票在开售后数分钟内售罄。',
    category: 'star',
    tags: ['程野', '巡演', '演唱会'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20male%20singer%20silhouette%20on%20a%20world%20tour%20stage%2C%20sweeping%20warm%20orange%20spotlights%2C%20confetti%2C%20dynamic%20concert%20poster%20composition%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-s2&orientation=landscape',
    author: '明星组',
    publishTime: '2026-10-15T22:15:00',
    views: 44100,
    shares: 3120,
    featured: true,
    paragraphs: [
      '歌手程野昨晚官宣启动全新世界巡演“回声十年”，首批公布五座城市。门票于今日上午十点开售，不到五分钟便宣告售罄，主办方随后宣布两站加场。',
      '此次巡演在舞台设计上强调“环绕式观演”，团队透露将使用可移动的中央舞台，让后排观众也能获得近距离体验。',
      '程野在个人社交账号发文感谢歌迷，并表示会把更多时间留给现场，“巡演是歌手和听众互相充电的地方”。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20film%20set%20with%20cameras%20and%20warm%20orange%20lighting%2C%20behind%20the%20scenes%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-01&orientation=landscape',
    ],
  },
  {
    id: 's3',
    title: '导演陈望山获国际电影节终身成就奖，现场致谢团队',
    summary: '在刚刚落幕的国际电影节上，导演陈望山获颁终身成就奖，他在致辞中把荣誉归功于一路同行的剧组伙伴。',
    category: 'star',
    tags: ['陈望山', '电影节', '荣誉'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20film%20director%20holding%20a%20lifetime%20achievement%20award%20on%20a%20festival%20stage%2C%20warm%20orange%20spotlight%2C%20elegant%20cinematic%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-s3&orientation=landscape',
    author: '影展观察员',
    publishTime: '2026-10-15T09:50:00',
    views: 21800,
    shares: 880,
    featured: false,
    paragraphs: [
      '国际电影节闭幕式上，导演陈望山获颁终身成就奖，以表彰其三十余年创作生涯中形成的独特影像语言。',
      '登台领奖时，陈望山把荣誉归功于团队。他说：“电影是很多人一起走很长的路，我只是恰好站在了最前面。”台下多位影人起立鼓掌。',
      '评委会在颁奖词中写道，他的作品始终关注普通人的处境，在时代洪流中留下了沉静而有力的注脚。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20movie%20ticket%20stub%20and%20popcorn%20with%20warm%20orange%20cinema%20light%2C%20cozy%20movie%20night%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-05&orientation=landscape',
    ],
  },
  {
    id: 's4',
    title: '小花旦苏晚晚跨界执导短片，入围青年影展',
    summary: '以甜美形象被观众熟知的苏晚晚首次拿起导演筒，其短片处女作入围青年影展，展现出不为人知的一面。',
    category: 'star',
    tags: ['苏晚晚', '导演', '短片'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20young%20actress%20directing%20with%20a%20camera%20on%20an%20indie%20film%20set%2C%20warm%20orange%20sunset%20light%2C%20creative%20editorial%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-s4&orientation=landscape',
    author: '明星组',
    publishTime: '2026-10-14T20:25:00',
    views: 19600,
    shares: 720,
    featured: false,
    paragraphs: [
      '演员苏晚晚的首部执导短片《晚风经过》确认入围青年影展。此前，她多以甜美形象出现在影视作品中，此次转战幕后让不少观众感到意外。',
      '短片以一位独居老人的日常为线索，全片只有二十多分钟，却花了近半年时间打磨。苏晚晚表示，自己更喜欢在监视器后面观察人物的状态。',
      '影展选片人评价说，作品节奏克制，镜头语言干净，看得出创作者对细节的耐心。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20television%20talk%20show%20set%20with%20warm%20orange%20accents%2C%20modern%20studio%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-04&orientation=landscape',
    ],
  },
  {
    id: 's5',
    title: '男团VANTA成员单飞不解散，首张个人专辑上线',
    summary: '人气男团VANTA成员陆屿发布首张个人专辑，组合方面强调“单飞是为了各自成长，集体仍会继续”。',
    category: 'star',
    tags: ['VANTA', '陆屿', '专辑'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20boy%20band%20member%20solo%20album%20cover%2C%20geometric%20warm%20orange%20and%20charcoal%20background%2C%20stylish%20minimal%20pop%20art%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=art-s5&orientation=landscape',
    author: '明星组',
    publishTime: '2026-10-13T18:00:00',
    views: 17300,
    shares: 1150,
    featured: false,
    paragraphs: [
      '人气男团VANTA成员陆屿于今日发布首张个人专辑《夜行》，整张专辑收录八首歌曲，其中五首由他本人参与词曲创作。',
      '针对组合是否会解散的疑问，经纪公司回应称，“单飞是为了各自成长，集体仍会继续活动”，年内组合将推出团体单曲。',
      '专辑上线首日即登上多个音乐榜单前列。乐评人认为，作品在流行旋律之外加入了更多乐队化的编排，显示出他摆脱偶像标签的尝试。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20recording%20studio%20microphone%20with%20warm%20orange%20glow%2C%20music%20production%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-03&orientation=landscape',
    ],
  },
  {
    id: 's6',
    title: '老戏骨周崇山新片杀青，坦言想演一次普通人',
    summary: '七十岁的周崇山完成新片拍摄，这位演了大半辈子“父亲”的演员说，自己最想演的还是街边修鞋匠那样的普通人。',
    category: 'star',
    tags: ['周崇山', '杀青', '新片'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20portrait%20of%20a%20seasoned%20asian%20actor%20in%20a%20serious%20drama%20role%2C%20warm%20orange%20side%20lighting%2C%20cinematic%20film%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-s6&orientation=landscape',
    author: '明星组',
    publishTime: '2026-10-13T10:20:00',
    views: 15800,
    shares: 540,
    featured: false,
    paragraphs: [
      '七十岁的老戏骨周崇山完成了新片《街角》的全部拍摄。杀青当天的片场照流出，他穿着洗得发白的旧外套，和工作人员一一握手道别。',
      '从艺五十余年，周崇山塑造过无数父亲形象。他坦言，自己最想演的其实是“街边修鞋匠那样的普通人”，“他们身上有我想找的那种安静的力量”。',
      '导演表示，这个角色几乎是照着周崇山身上的气质写的。影片预计于明年上半年与观众见面。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20film%20set%20with%20cameras%20and%20warm%20orange%20lighting%2C%20behind%20the%20scenes%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-01&orientation=landscape',
    ],
  },
  {
    id: 'h1',
    title: '热搜第一：某综艺剪辑争议持续发酵，节目组深夜回应',
    summary: '因剪辑呈现引发争议，一档热门综艺连续两天占据热搜榜首位，节目组于凌晨发布长文回应，承诺调整后续呈现方式。',
    category: 'hot',
    tags: ['热搜', '综艺', '争议'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20glowing%20editing%20timeline%20with%20film%20frames%20on%20a%20dark%20desk%2C%20warm%20orange%20screen%20light%2C%20editorial%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-h1&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-16T07:40:00',
    views: 62700,
    shares: 4520,
    featured: true,
    paragraphs: [
      '一档正在热播的真人秀因剪辑呈现方式引发广泛讨论，相关话题连续两天占据热搜榜首位。网友认为节目中的叙事顺序容易让观众对某位嘉宾产生误解。',
      '当日凌晨，节目组发布长文回应，先是感谢观众对节目的关注，随后承认在剪辑节奏上“处理得不够周全”，并表示后续会调整呈现方式、补充更多完整片段。',
      '截至发稿，相关话题阅读量已突破八亿。多位参与节目的嘉宾暂未作个人回应，粉丝则呼吁理性讨论、不要过度解读。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20social%20media%20trending%20phone%20screen%20with%20warm%20orange%20notification%20glow%2C%20internet%20buzz%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-06&orientation=landscape',
    ],
  },
  {
    id: 'h2',
    title: '“电子榨菜”再出爆款，短剧《十分钟恋爱》播放破十亿',
    summary: '一部每集十分钟的短剧上线两周播放量突破十亿，成为“电子榨菜”热潮中的又一现象级作品。',
    category: 'hot',
    tags: ['短剧', '爆款', '电子榨菜'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20smartphone%20playing%20a%20vertical%20short%20drama%2C%20warm%20orange%20glow%2C%20pop%20culture%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=art-h2&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-15T20:50:00',
    views: 48900,
    shares: 2890,
    featured: false,
    paragraphs: [
      '一部名为《十分钟恋爱》的短剧上线仅两周，全网播放量突破十亿，相关片段被反复搬运，成为“电子榨菜”热潮中的又一现象级作品。',
      '该剧每集十分钟，主要场景集中在一间咖啡店，靠密集的反转与生活化的台词留住观众。制作方透露，全剧拍摄周期不到三周，成本远低于传统剧集。',
      '有观察者指出，短剧的爆发改变了内容消费的节奏，但也带来同质化隐忧。如何在“爽感”之外做出差异化，是行业接下来要回答的问题。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20television%20talk%20show%20set%20with%20warm%20orange%20accents%2C%20modern%20studio%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-04&orientation=landscape',
    ],
  },
  {
    id: 'h3',
    title: '网友晒出十年前追星旧照，掀起全民回忆杀',
    summary: '一个“晒出你的追星旧照”话题意外刷屏，泛黄的海报、手写的歌词本与褪色的门票，勾起了许多人的青春记忆。',
    category: 'hot',
    tags: ['回忆杀', '追星', '话题'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20old%20concert%20photos%20and%20tickets%20scattered%20on%20a%20warm%20table%2C%20nostalgic%20orange%20tone%2C%20vintage%20fan%20memory%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-h3&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-15T15:20:00',
    views: 36400,
    shares: 3410,
    featured: false,
    paragraphs: [
      '近日，一个“晒出你的追星旧照”话题意外刷屏。泛黄的海报、手写的歌词本、褪色的演唱会门票，让许多网友感慨“原来青春真的有声音”。',
      '话题发起者是一位普通上班族，她说原本只是想整理旧物，没想到引发了这么多共鸣。评论区里，来自不同城市的网友分享着各自的故事。',
      '有心理学者分析，这类怀旧话题之所以传播广泛，是因为它把个体的私人记忆连接成了公共情感，让人们在快节奏的生活中找到片刻的安放。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20crowded%20red%20carpet%20event%20with%20warm%20orange%20flash%20lights%2C%20glamorous%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-02&orientation=landscape',
    ],
  },
  {
    id: 'h4',
    title: 'AI换脸翻唱引版权争议，多位歌手工作室发声',
    summary: '用AI技术合成歌手声线并翻唱他人作品的行为引发版权讨论，多家工作室先后发布声明，呼吁规范技术使用。',
    category: 'hot',
    tags: ['AI', '版权', '争议'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20face%20made%20of%20glowing%20digital%20pixels%20inside%20a%20microphone%2C%20warm%20orange%20tech%20glow%2C%20editorial%20controversy%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-h4&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-14T22:40:00',
    views: 29700,
    shares: 1760,
    featured: false,
    paragraphs: [
      '近期，一些账号利用AI技术合成知名歌手的声线翻唱其他作品，相关视频获得大量传播，也迅速引发版权与人格权方面的讨论。',
      '已有多个歌手工作室发布声明，明确表示未授权此类合成使用，并保留追究责任的权利。与此同时，也有从业者认为，技术本身中立，关键在于使用边界。',
      '法律界人士提醒，若合成内容涉及他人声音特征与已发表作品，可能同时触及人格权与著作权问题；普通网友在转发时同样需要留意风险。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20recording%20studio%20microphone%20with%20warm%20orange%20glow%2C%20music%20production%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-03&orientation=landscape',
    ],
  },
  {
    id: 'h5',
    title: '演唱会门票实名制升级，黄牛产业链遭重创',
    summary: '多场大型演出启用更强的实名核验机制，入场需人脸比对，票务倒卖空间被大幅压缩。',
    category: 'hot',
    tags: ['演出', '实名制', '票务'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20a%20concert%20ticket%20with%20a%20digital%20identity%20scan%20gate%2C%20warm%20orange%20light%2C%20modern%20event%20security%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-h5&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-14T14:10:00',
    views: 25300,
    shares: 1290,
    featured: false,
    paragraphs: [
      '随着新一轮大型演出的集中开票，多个主办方升级了实名制核验机制：购票人须与入场人一致，现场还需进行人脸比对，票务转让被严格限制。',
      '新规实施后，长期活跃的票务倒卖空间被大幅压缩。多位歌迷表示，这是近年来“最像样的一次票务治理”。',
      '也有主办方工作人员坦言，核验环节增加后，入场效率需要重新平衡。如何在治理倒卖与保障顺畅入场之间找到更优解，仍在探索之中。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20movie%20ticket%20stub%20and%20popcorn%20with%20warm%20orange%20cinema%20light%2C%20cozy%20movie%20night%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-05&orientation=landscape',
    ],
  },
  {
    id: 'h6',
    title: '跨界联名潮席卷娱乐圈，影视周边成新消费风口',
    summary: '从文创到餐饮，娱乐IP的跨界联名遍地开花，围绕影视周边的消费热潮正在形成新的增长点。',
    category: 'hot',
    tags: ['联名', '周边', '消费'],
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20colorful%20entertainment%20merch%20products%20and%20gift%20boxes%20on%20a%20shelf%2C%20warm%20orange%20accent%20light%2C%20pop%20retail%20mood%2C%20charcoal%20and%20amber%20palette%2C%20no%20text&width=800&height=500&seq=art-h6&orientation=landscape',
    author: '热点追踪',
    publishTime: '2026-10-13T19:30:00',
    views: 21400,
    shares: 980,
    featured: false,
    paragraphs: [
      '近一个月来，多部热门影视作品接连推出跨界联名，从文创文具到联名餐饮，娱乐IP的身影几乎无处不在，围绕周边的消费热潮持续升温。',
      '某平台数据显示，热门剧集相关周边的搜索量环比增长明显，限量款常常在上架后短时间内售罄。年轻消费者成为这轮热潮的主力。',
      '业内人士认为，联名的本质是情感的延伸。观众愿意为喜欢的角色买单，但若产品本身缺乏诚意，热度褪去后也很难留下真正的口碑。',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20social%20media%20trending%20phone%20screen%20with%20warm%20orange%20notification%20glow%2C%20internet%20buzz%20mood%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=800&height=500&seq=inline-06&orientation=landscape',
    ],
  },
];

export const heroSlides = [
  {
    id: 'n1',
    image:
      'https://readdy.ai/api/search-image?query=Wide%20stylized%20cinematic%20banner%20of%20a%20glowing%20concert%20stage%20and%20sweeping%20orange%20spotlights%2C%20dark%20atmospheric%20entertainment%20hero%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=hero-01&orientation=landscape',
  },
  {
    id: 'n2',
    image:
      'https://readdy.ai/api/search-image?query=Wide%20stylized%20cinematic%20banner%20of%20a%20grand%20awards%20ceremony%20stage%20with%20golden%20trophy%20glow%20and%20warm%20orange%20spotlights%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=hero-02&orientation=landscape',
  },
  {
    id: 'n3',
    image:
      'https://readdy.ai/api/search-image?query=Wide%20stylized%20sci-fi%20banner%20of%20a%20planet%20above%20a%20futuristic%20city%20skyline%2C%20warm%20orange%20and%20charcoal%20palette%2C%20cinematic%20lighting%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=hero-03&orientation=landscape',
  },
  {
    id: 's2',
    image:
      'https://readdy.ai/api/search-image?query=Wide%20stylized%20cinematic%20banner%20of%20a%20singer%20silhouette%20on%20a%20stadium%20stage%20with%20sweeping%20warm%20orange%20lights%20and%20confetti%2C%20charcoal%20and%20amber%20palette%2C%20soft%20grain%2C%20no%20text&width=1600&height=900&seq=hero-04&orientation=landscape',
  },
];